export default __webpack_public_path__ + "static/media/fantomicon.40755d1e.png";